/*
 * @description: 接口定义
 * @Author: Jay
 * @Date: 2021-07-23 09:34:40
 * @LastEditors: Jay
 * @LastEditTime: 2024-12-05 13:27:13
 */
import request from '../utils/request'
import operate from "@/utils/operate";

// 获取首页配置
export function deployData(data) {
    return request({
        url: "/api2/area/index",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

//账号/密码登录
export function passLogin(data) {
    return request({
        url: "/api2/user/login",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

//动态路由
export function dynamicRouting(data) {
    return request({
        url: "/api2/wxpay/h5_menu",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

//找回密码
export function thirdPass(data) {
    return request({
        url: "/api2/user/third",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

//退出登录
export function logout(data) {
    return request({
        url: "/api2/user/logout",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 获取省份
export function provinceReq(data) {
    return request({
        url: "/api2/area/province",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 获取城市
export function cityReq(data) {
    return request({
        url: "/api2/area/city",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 获取区/县-
export function countyReq(data) {
    return request({
        url: "/api2/area/county",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 获取经营类目
export function categoryReq(data) {
    return request({
        url: "/api2/area/category",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 获取银行行别
export function bankReq(data) {
    return request({
        url: "/api2/area/bank",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 获取支行信息
export function branchReq(data) {
    return request({
        url: "/api2/area/bank2",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 获取商户类型(MCC)
export function merchantMcc(data) {
    return request({
        url: "/api2/area/mcc",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 隐私协议
export function agreementDetails(data) {
    return request({
        url: "/api2/area/details",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 会员中心-通知列表
export function noticeList(data) {
    return request({
        url: "/api2/user/notice_list",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 会员中心-通知详情
export function noticeInfo(data) {
    return request({
        url: "/api2/user/notice_info",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 瑞银信 经营范围
export function ryxType(data) {
    return request({
        url: "/api2/area/ryx_type",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 瑞银信 mcc类型
export function ryxMcc(data) {
    return request({
        url: "/api2/area/ryx_mcc",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 合利宝-获取省-市-县/区
export function hlbArea(data) {
    return request({
        url: "/api2/area/hlb_area",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 合利宝-获取类别
export function hlbType(data) {
    return request({
        url: "/api2/area/hlb_type",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 合利宝-获取mcc
export function hlbMcc(data) {
    return request({
        url: "/api2/area/hlb_mcc",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 微信渠道商号列表
export function kftWxQd(data) {
    return request({
        url: "/api2/area/kft_wx_qd",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}

// 支付宝渠道商号列表
export function kftAlipayQd(data) {
    return request({
        url: "/api2/area/kft_alipay_qd",
        method: "POST", // 请求方式
        data: data, // 数据
        token: operate.isToken()
    })
}